import { Pipe, PipeTransform } from '@angular/core';
import { IAddress } from 'src/app/models/profile.model';
import { TranslateService } from '@ngx-translate/core';
import { DeliveryPoint } from '../../models/address';

@Pipe({
  name: 'serializeAddress'
})
export class SerializeAddressPipe implements PipeTransform {

  constructor(
    public translateService: TranslateService
  ) {
  }

  transform(address: DeliveryPoint | null): string {
    if (!address) {
      return '';
    }
    const res: string[] = [];
    if ('apartment' in address && address.apartment) {
      let apartment = this.translateService.instant('FORM.APPARTMENT');
      res.push(`${apartment} ${(address as IAddress).apartment}`);
    }
    if (address.house) {
      res.push(address.street, address.house);
    }
    if (address.city) {
      res.push(address.city);
    }
    if (address.region) {
      res.push(address.region);
    }
    return res.join(', ');
  }
}
